export const blockIconsSocialFaceNew = (
	<span className='material-symbols-outlined'>face</span>
);
